import i18n from 'i18next'
import React from 'react'
import Text from '#components/a/Text'
import NavAusbildungsplan from '#components/svg/icons/NavAusbildungsplan'
import NavStatusUebersicht from '#components/svg/icons/NavStatusUebersicht'
import NavVersetzungsplan from '#components/svg/icons/NavVersetzungsplan'

export function BerufwechselConfirmModalContent() {
  return (
    <div>
      <Text modifier="above-delete-list" text={i18n.t('berufwechsel_confirmation_dialog_text_1')} />
      <div className="berufewechsel-modal__delete-list">
        <div className="berufewechsel-modal__delete-list-item">
          <NavAusbildungsplan />
          <Text modifier="ausbildungsplan" text={i18n.t('ausbildung_tab_plan')} />
        </div>
        <div className="berufewechsel-modal__delete-list-item">
          <NavStatusUebersicht />
          <Text modifier="praxisaufgaben" text={i18n.t('ausbildung_tab_status')} />
        </div>
        <div className="berufewechsel-modal__delete-list-item">
          <NavVersetzungsplan />
          <Text
            modifier="ablauf-und-termine"
            text={`${i18n.t('ausbildung_tab_versetzungsplan')} ${i18n.t(
              'berufwechsel_confirmation_dialog_ablauf_und_termine_note',
            )}`}
          />
        </div>
      </div>
      <Text text={i18n.t('berufwechsel_confirmation_dialog_text_2')} />
    </div>
  )
}
